import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import TipsPickupCalibration from 'contents/HardwareSettings/TipsPickupCalibration/TipsPickupCalibration';

import ProtocolExplorer from '../ProtocolExplorer/ProtocolExplorer';
import TrayCalibrationContainer from '../TrayCalibration/TrayCalibrationContainer';
import PlateTypeEditorContainer from '../PlateTypeEditor/PlateTypeEditorContainer';
import ProtocolEditor from '../ProtocolEditor/ProtocolEditor';
import UserManagementContainer from '../UserManagement/UserManagementContainer';
import LoginPage from '../Login/LoginPage';
import Runtime from '../Runtime/Runtime';
import NormalizationContainer from '../Normalization/NormalizationContainer';
import AboutContainer from '../About/AboutContainer';
import LabwareManager from '../LabwareManager/LabwareManager';
import DispenseReportExplorer from '../DispenseReport/DispenseReportExplorer';
import LogList from '../LogList/LogList';

import {ViewMode} from '../../constants/dataEnum';

import withIntl from '../../lib/withIntl';

import SetupWizard from '../SetupWizard/SetupWizard';
import ReteachPlate from '../ReteachPlate/ReteachPlate';

function PageContent({appStateViewMode, intl}) {
  let pageContent = '';
  let pageTitle = '';
  switch (appStateViewMode) {
    case ViewMode.EXPLORER:
      pageContent = <ProtocolExplorer />;
      pageTitle = intl.formatMessage({id: 'PageContent.pageTitle.explorer'});

      break;
    case ViewMode.TRAY_CALIBRATION:
      pageContent = (
        <div className="bootstrap-iso">
          <TrayCalibrationContainer />
        </div>
      );
      pageTitle = intl.formatMessage({id: 'PageContent.pageTitle.trayCalibration'});

      break;
    case ViewMode.LABWARE_MANAGER:
      pageContent = <LabwareManager />;
      pageTitle = intl.formatMessage({id: 'PageContent.pageTitle.labwareManager'});

      break;
    case ViewMode.RETEACH_PLATE:
      pageContent = <ReteachPlate />;
      pageTitle = intl.formatMessage({id: 'PageContent.pageTitle.reteachPlate'});

      break;
    case ViewMode.SETUP_WIZARD:
      pageContent = <SetupWizard />;
      pageTitle = intl.formatMessage({id: 'PageContent.pageTitle.setupWizard'});

      break;
    case ViewMode.DISPENSE_REPORT_EXPLORER:
      pageContent = <DispenseReportExplorer />;
      pageTitle = intl.formatMessage({id: 'PageContent.pageTitle.dispenseReportExplorer'});

      break;
    case ViewMode.LOG_LIST:
      pageContent = <LogList />;
      pageTitle = intl.formatMessage({id: 'PageContent.pageTitle.logList'});

      break;
    case ViewMode.PLATE_TYPE_EDITOR:
      pageContent = (
        <div className="bootstrap-iso">
          <PlateTypeEditorContainer />
        </div>
      );
      pageTitle = intl.formatMessage({id: 'PageContent.pageTitle.plateTypeEditor'});
      break;
    case ViewMode.PROTOCOL_EDITOR:
      pageContent = (
        <div className="bootstrap-iso">
          <ProtocolEditor />
        </div>
      );
      pageTitle = intl.formatMessage({id: 'PageContent.pageTitle.protocolEditor'});
      break;
    case ViewMode.NORMALIZATION_OLD:
      pageContent = <NormalizationContainer />;
      pageTitle = intl.formatMessage({id: 'PageContent.pageTitle.normalization'});
      break;
    case ViewMode.USER_MANAGEMENT:
      pageContent = <UserManagementContainer />;
      pageTitle = intl.formatMessage({id: 'PageContent.pageTitle.userManagement'});
      break;
    case ViewMode.LOGIN:
    case ViewMode.LOGIN_CONFIRMATION:
      pageContent = (
        <div className="bootstrap-iso">
          <LoginPage />
        </div>
      );
      pageTitle = intl.formatMessage({id: 'PageContent.pageTitle.login'});
      break;
    case ViewMode.RUNTIME:
      pageTitle = intl.formatMessage({id: 'PageContent.pageTitle.runtime'});
      pageContent = (
        <div className="bootstrap-iso">
          <Runtime />
        </div>
      );
      break;
    case ViewMode.ABOUT:
      pageTitle = intl.formatMessage({id: 'PageContent.pageTitle.about'});
      pageContent = (
        <div className="bootstrap-iso">
          <AboutContainer />
        </div>
      );
      break;
    case ViewMode.TIPS_PICKUP_CALIBRATION:
      pageTitle = intl.formatMessage({id: 'tipsPickupCalibration.pageTitle.a1OffsetCalibration'});
      pageContent = <TipsPickupCalibration />;
      break;
    default:
      break;
  }
  document.title = pageTitle;
  return <div id="content">{pageContent}</div>;
}

function mapStateToProps(state) {
  return {
    appStateViewMode: state.appState.viewMode,
    signalrState: state.signalrState,
  };
}

PageContent.propTypes = {
  intl: PropTypes.any.isRequired,
  appStateViewMode: PropTypes.string.isRequired,
};

export default connect(mapStateToProps)(withIntl(PageContent));
